<template>
  <DBox
    :id="'cmp-booking-tasks-task_details-local_details_relation-box'"
    :addButton="false"
    :addLink="false"
  >

    <NTable
      class="artist-list dbox1"
      :id="'booking-tasks-task_details-local_details_relation-table'"
      :headers="relationHeader"
      :items="localDetails"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('type')">
            <span>{{
              item["local_details_type_name"]
            }}</span>
          </td>
          <td v-bind="tdcon('name')">
            <span>{{ item["name"] }}</span>
          </td>
          <td v-bind="tdcon('contact')">
            <div class="ut-flex">
              <div class="dt-icon-container">
                <img
                  :title="item['phone']"
                  :class="{ inactive: !item['phone'] }"
                  src="static/icons/phone.svg"
                  class="dt-icon v5 s1"
                  alt="Call"
                  @click="(e) => callLocalDetails(item, e)"
                />
              </div>
              <div class="dt-icon-container">
                <img
                  :title="item['email']"
                  :class="{ inactive: !item['email'] }"
                  src="static/icons/email/email-grey.svg"
                  class="dt-icon v5 s1"
                  alt="Email"
                  @click="(e) => mailLocalDetails(item, e)"
                />
              </div>
              <div class="dt-icon-container">
                <img
                  :title="item['url']"
                  :class="{ inactive: !item['url'] }"
                  src="static/icons/web.svg"
                  class="dt-icon v5 s1"
                  alt="Web"
                  @click="(e) => visitLocalDetails(item, e)"
                />
              </div>
            </div>
          </td>
          <td v-bind="tdcon('related_contact')" style="border-right: none">
            <span :title="item['contact_person_realted_name']">{{
              item["contact_person_realted_name"]
            }}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import * as R from "ramda";
import * as querystring from "querystring";
import { openWindow, sendMail } from "../../../../utility";
import { defaultTo, propOr } from "ramda";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
export default {
  components: {
  },
  props: ["localDetails"],
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  mounted: async function () {},
  // mixins: [createModalMixin("localDetails"), createModalMixin("loadPromoterDefault")],
  computed: {
    relationHeader: function () {
      return [
        createTableHeader("type", {}),
        createTableHeader("name"),
        createTableHeader("contact", { mw: 90 }),
        createTableHeader("related_contact", { f: 1.8 }),
        // createTableHeader("lock", { mw: 30, text: false }),
        // createTableHeader("options", { mw: 30, text: false }),
      ];
    },
  },
  methods: {
    onLocalHotelMailClick: function (localDetails) {
      const { email } = localDetails;
      sendMail({
        body: "",
        subject: "Book Hotel Link",
        mails: [email],
      });
    },
    createMailString: function (url, email) {
      return `mailto:${email}?${querystring.stringify({
        subject: "Book Hotel Link",
        body: url,
      })}`;
    },
    callLocalDetails: function (item, e) {
      if (item["phone"]) {
        openWindow(`tel:${item["phone"]}`);
        e.stopPropagation();
      }
    },
    mailLocalDetails: function (item, e) {
      if (item["email"]) {
        // openWindow(`mailto:${localDetails["email"]}`);
        sendMail({
          mails: [item["email"]],
        });
        e.stopPropagation();
      }
    },
    visitLocalDetails: function (item, e) {
      if (item["url"]) {
        window.open(`http://${item["url"]}`, "_blank");
        e.stopPropagation();
      }
    }
  },
};
</script>

<style scoped lang="scss">
.booking-tasks-task_details-local_details_relation-table{
  --ntable-height: auto !important;
}
</style>
